// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* Vue & Vuex */
import Vue from 'vue';
import Vuex from 'vuex';
import createVuexStore from '@/vuex/vuex';
import {
  BLOCK_INTERFACE, RELEASE_INTERFACE, LOGOUT,
  CLEAR_UNAUTH_REDIRECT, RESTART_SESSION,
} from '@/vuex/types/actions';
import perms from '@/libs/permissions';

import '@/start';
import jshelper from '@/libs/helper';

/* Sweet Scroll */
import SweetScroll from 'sweet-scroll';

/* Custom Class Imports */
import Requests from './requests/requests';

/* App & Router */
import App from './App';
import router from './router';

/* eslint-disable */
Vue.config.productionTip = false;
Vue.use(Vuex);

/* Vuex Store Instance*/
const store = createVuexStore();

/* Router Custom Behaviour */
router.beforeEach((to, from, next) => {
  const user = store.getters.user;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!user) {
      next({
        name: 'Login',
        query: { redirect: to.fullPath }
      });
      return;
    }

    if (user.teamsAreaRequired === true && to.name !== 'TeamsArea') {
      next({
        name: 'TeamsArea'
      });
      return;
    }

    if (user.teamsAreaRequired !== true && to.name === 'TeamsArea') {
      next({
        name: 'MyDeals'
      });
      return;
    }
  }

  if (to.matched.some(record => record.meta.requiresUnauth) && user) {
    next({ name: 'MyDeals' });
    return;
  }

  if (to.matched.some(record => record.meta.requiresVerification) && !user.verified) {
      next({ name: 'MyDeals' });
      return;
  }

  if (to.matched.some(record => record.meta.requiresPermission
    && !perms.checkPermissions(record.meta.allowedPermissions))) {
    next({name: 'Settings'});
    return;
  }

  if (to.matched.some(record => record.meta.requiresLowerEnv) && process.env.NODE_ENV === 'production') {
    next({
      name: 'Login',
    });
    return;
  }

  next();
});

/* Vue Instance */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store: store,
  computed: Vuex.mapState({
    isAuthenticated: state => state.user != null,
  }),
  watch: {
    isAuthenticated(newValue, oldValue) {
      if (oldValue === false && newValue === true) {
        if (store.getters.unauthRedirect) {
          this.$router.push(store.getters.unauthRedirect);
          store.dispatch(CLEAR_UNAUTH_REDIRECT);
        } else {
          this.$router.push(
            this.$route.query.redirect ||
            {
              name: ['Registration', 'Login', 'Contributor', 'Index'].includes(this.$route.name) ?
                'MyDeals' : this.$route.name
            }
          );
        }
      } else if (newValue === false && oldValue === true) {
        this.$router.push({ name: 'Login' });
      } else {
        this.$router.push({ name: 'Index' });
      }
    },
  },
  methods: {
    unauthorizedHandler() {
      store.dispatch(LOGOUT);
      Vue.notify({
        group: 'alert',
        text: 'It seems that your session is no longer active. Please log in again.',
        type: 'error',
      });
    },
    errorHandler(err) {
      const title = err && err.data && err.data.message ?
        err.data.message :
        'We could not process your request, please try again later.';

      let textItems = '';
      const errors = err.data.errors;
      if (Array.isArray(errors)) {
        textItems = errors.map(error => `<li>${jshelper.decodeHtml(error)}</li>`)
      } else {
        textItems = Object.keys(errors || {}).map((key) => {
          const error = errors[key];
          let desc = error;
          if (Array.isArray(error)) {
            desc = error.join(', ');
          } else if (typeof error === 'object') {
            desc = Object.keys(error).map(eKey => error[eKey]).join(', ');
          }

          const readableKeys = key.match(/[A-Za-z][a-z]*/g) || [];
          const words = readableKeys.map(w => w.charAt(0).toUpperCase() + w.substring(1));
          return `<li>${words.join(' ')}: ${jshelper.decodeHtml(desc)}.</li>`;
        });
      }

      const text = textItems.length > 0 ?
        `<ul style="list-style:none;padding-left:0;">${textItems.join('')}</ul>` : null;

      Vue.notify({ title: jshelper.decodeHtml(title), text, group: 'alert', type: 'error' });
    },
    _installRequests() {
      if (Vue.prototype.hasOwnProperty('$reqs')) { return; }

      const reqs = new Requests(
        () => (store.dispatch(BLOCK_INTERFACE)),
        () => {
          store.dispatch(RELEASE_INTERFACE);

          const user = store.getters.user;
          if(user) {
            store.dispatch(RESTART_SESSION);
          }

        },
        (error) => {
          if (error.status === 401) {
            this.unauthorizedHandler()
          } else {
            this.errorHandler(error);
          }
        },
      );

      Object.defineProperty(Vue.prototype, '$reqs', {
        get: function get() { return reqs; }
      });
    },
    _installScroller() {
      const scroller = new SweetScroll();

      Object.defineProperty(Vue.prototype, '$scroller', {
        get: function get() { return scroller; }
      });
    },
    _installPermissions() {
      const permissions = perms;
      Object.defineProperty(Vue.prototype, '$permissions', {
        get: function get() { return permissions; }
      });
    },
  },
  created() {
    this._installRequests();
    this._installScroller();
    this._installPermissions();
  },
  beforeRouteEnter() {
    this.$scroller.to(0);
  },
});

Vue.directive('permission', {
  bind: function (el, binding, vnode) {
    const result = perms.checkPermissions(binding.value);
    if (!result) {
      el.style.display = 'none';
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js